import React from "react";
import _ from "lodash";
import { Typography } from "antd";
import { ExternalLinkIcon } from "components/Icons";
import classNames from "classnames";
const { Text, Paragraph, Link } = Typography

const DescriptionItem = ({ title, content, align, contentEllipsis = {}, linkHref, textClass, extra = null }) => {
    const linkComponent = <Link target="_blank" href={linkHref} >{content} <ExternalLinkIcon /></Link>
    return (
        <div className="site-description-product-profile-wrapper">
            <div className="description-space-node" align={align} >
                <Text strong className="pull-left m-r-xs">{title}:</Text>
                {
                    linkHref ? <>{linkComponent} {extra}</> : _.isEmpty(contentEllipsis) ? <span className={textClass}>{content} {extra}</span> :
                        <Paragraph className={classNames(textClass, 'm-b-0')}  ellipsis={contentEllipsis}>
                            {content}
                        </Paragraph>
                }
            </div>
        </div>
    )
}
export default DescriptionItem;
